// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Karla:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-form-container {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: white;
}

.request-container {
  font-family: "Karla", sans-serif;
  width: 100%;
  height: 100%;
  background-color: white;
  color: black;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.apply-button-container {
  position: relative;
  display: flex;
  gap: 10px;
  align-self: flex-end;
}

.apply-button {
  background-color: #84c7ae;
  color: white;
  margin-bottom: 0px;
  border: 2px solid #84c7ae;
  padding: 4px 7px;
  font-family: "Karla", sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.balance-button {
  margin-right: 20px;
}

.apply-button:hover {
  background-color: #75b39d;
}

.dropdown-menu {
  position: absolute;
  margin-top: 5px;
  top: 100%;
  right: 0;
  background-color: white;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.dropdown-menu button {
  display: block;
  width: 100%;
  padding: 6px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-family: "Karla", sans-serif;
  font-size: 12px;
  color: black;
  white-space: nowrap;
}

.dropdown-menu button:hover {
  background-color: #f0f0f0;
}

h2 {
  margin-top: 5px;
  font-weight: 700;
}

.table-responsive {
  overflow-x: auto;
  flex-grow: 1;
}

table {
  width: 100%;

  /* border-collapse: separate; */
  border-spacing: 0 5px;
  margin-top: -5px;

  border: 1px solid #d9e3d9;
}

th,
td {
  padding: 4px 1px;
  text-align: left;
}

th {
  font-weight: 700;
  background: rgba(222, 236, 221, 0.32);
  margin-bottom: 10px;
}
tbody tr:nth-child(odd) {
  /* border: 1px solid #000; */
  background-color: #c6bcbc37;
}

tbody td {
  font-weight: 600;
  font-size: 11px;
  text-align: center;
  /* border-top: 1px solid #d9e3d9; */
  /* border: 1px solid gray; */
}

.action-icons {
  display: flex;
  gap: 20px;
}

.action-icon {
  cursor: pointer;
  transition: opacity 0.3s ease;
  color: #84c7ae;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));
}

.action-icon:hover {
  opacity: 0.7;
}

/* Tablet view: 768px to 1023px */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .request-container {
    font-family: "Karla", sans-serif;
    width: 100%;
    height: 100%;
    background-color: white;
    color: black;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  .apply-button-container {
    position: relative;
    display: flex;
    align-self: flex-end;
  }
  .applied_main_container {
    height: 200px;
    display: flex;
    flex-direction: column;
  }
  .request_heading {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 5px;
  }
 
  .table-responsive {
    overflow-x: auto;
    flex-grow: 1;
  }
  .table-responsive table {
    width: 100%;
    /* border-collapse: separate; */
    border-spacing: 0 5px;
    margin-top: -5px;
    border: 1px solid #d9e3d9;
  }
  .table-responsive th {
    background-color: #deecdd;
    position: sticky;
    top: 0;
    text-align: center;
    font-weight: 700;
    background: rgba(222, 236, 221, 0.32);
    margin-bottom: 10px;
    padding: 4px 1px;
  }
  .table-responsive tbody tr:nth-child(odd) {
    /* border: 1px solid #000; */
    background-color: #c6bcbc37;
  }
  .applied_main_container {
    height: 200px;
    display: flex;
    flex-direction: column;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .apply-button {
    font-size: 14px;
    padding: 8px 16px;
  }

  h2 {
    font-size: 18px;
  }

  td {
    font-size: 12px;
  }

  .action-icons {
    gap: 10px;
  }

  .action-icon {
    font-size: 14px;
  }
}
/* 
.iconCloseBtn {
  position: absolute;
  top: 16%;
  right: 1%;
  transform: translateX(-10%, -10%); */

/* z-index: 2;
} */
/* .iconCloseBtn:hover {
  cursor: pointer;
} */

.alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.alert-box {
  width: 60vw;
  height: 97vh;
  max-width: 90%;
  position: relative;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 1.5rem;
  color: #fff;
  cursor: pointer;
}

/* .close-icon:hover {
  color: #007bff;
} */

.request_heading {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 5px;
}
.request_highlight_leave {
  color: rgb(205, 102, 102);
  cursor: pointer;
}

/* .requestByMe_container{
  height: 550px;
} */
.applied_main_container {
  height: 200px;
  display: flex;
  flex-direction: column;
}

table th {
  background-color: #deecdd;
  position: sticky;
  top: 0;
  text-align: center;
}
 .reason-column{
 max-width: 100px;
 }
 .name-column{
  max-width: 60px;
 }
.crossIconOfNewAsset {
  align-content: center;
  margin-left: 520px;
  position: absolute;
  margin-top: 0px;
  z-index: 2;
  color: white;
  font-size: xx-large;
  font-weight: 600;
}

.revoke_icon {
  color: #84c7ae;
  cursor: pointer;
  font-size: 20px;
  margin-left: 10px;
}
/* leave balance css */
.leave-balance-popup {
  position: fixed;
  top: 100px;
  left: 250px;
  width: 60%;
  height: auto;
  max-height: 80%;
  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  z-index: 1000;
  border: 5px solid #ccc;
  border-radius: 10px;
  overflow-y: auto;
}

.leaveBalance_heading {
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #0d7c66;
}

.leave-balance-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
}

.leave-balance-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  width: 120px;
  position: relative;
}

.leave-balance-item:not(:last-child)::after {
  content: "";
  position: absolute;
  right: -20px;
  top: 20%;
  height: 60%;
  width: 1px;
  background-color: #ccc;
}

.leave-day_border {
  height: 4rem;
  width: 4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #84c7ae;
  border: #75b39d 3px solid;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.leave-type {
  font-size: 18px;
  font-weight: 500;
  color: #0d7c66;
  margin-top: 10px;
  text-align: center;
}

.leave-days {
  font-size: 24px;
  font-weight: 700;
  color: white;
}

.crossIconOfleaveBalance {
  top: 10px;
  right: 10px;
  position: absolute;
  z-index: 2;
  color: rgb(96, 88, 88);
  font-size: x-large;
  font-weight: 600;
  cursor: pointer;
}

@media screen and (max-width: 767px) {
  .request-container {
    padding: 10px;
    flex-direction: column;
    align-items: stretch;
  }

  .apply-button-container {
    flex-direction: row;
    /* align-items: initial; */
    width: 100%;
    gap: 5px;
  }

  .apply-button {
    font-size: 12px;
    padding: 6px 10px;
    width: 100%;
    justify-content: space-between;
  }

  .dropdown-menu {
    width: 100% !important;
    right: 0;
    left: 0;
    top: 100%;
  }

  .popup-main {
    width: 100%;
    padding: 10px;
    overflow-y: auto;
    max-height: 90vh;
  }

  .crossIconOfNewAsset,
  .crossIconOfleaveBalance {
    margin-left: auto !important;
    margin-right: 10px;
    position: absolute;
    top: 9px;
    right: -4px;
    font-size: 20px;
  }

  .leave-balance-popup {
    top: 60px;
    left: 5%;
    width: 90%;
    padding: 15px;
    border: 3px solid #ccc;
  }

  .leaveBalance_heading {
    font-size: 24px;
  }

  .leave-balance-list {
    gap: 20px;
  }

  .leave-type {
    font-size: 14px;
  }

  .leave-days {
    font-size: 20px;
  }

  .table-responsive {
    overflow-x: auto;
    height: 200px;
  }

  table {
    font-size: 12px;
    min-width: 600px;
  }

  .request_heading {
    font-size: 16px;
    text-align: center;
  }

  .action-icon {
    font-size: 16px;
  }

  .alert-box {
    width: 95vw;
    height: 90vh;
  }

  .applied_main_container {
    height: auto;
  }

  .table-responsive td {
    padding: 0px;
  }
  .apply-button-container button {
    font-size: medium;
  }
}

@media screen and (max-width: 550px) {
  .request-container {
    padding: 8px;
  }

  .apply-button {
    font-size: 10px;
    padding: 4px 8px;
  }

  .leaveBalance_heading {
    font-size: 20px;
  }

  .leave-type {
    font-size: 12px;
  }

  .leave-days {
    font-size: 18px;
  }
   table{
    font-size: 12px;
    min-width: fit-content;
  }
   .table-responsive {
    overflow-x: auto;
    min-width: 300px;
  }
  .table-responsive table {
    /* width: 100%; */
    /* border-collapse: separate; */
    border-spacing: 0 5px;
    margin-top: -5px;
    border: 1px solid #d9e3d9;
  }
  .table-responsive th {
    background-color: #deecdd;
    position: sticky;
    top: 0;
    text-align: center;
    font-weight: 550;
    background: rgba(222, 236, 221, 0.32);
    margin-bottom: 10px;
    padding: 2px 1px;
  }
  .table-responsive tbody tr:nth-child(odd) {
    /* border: 1px solid #000; */
    background-color: #c6bcbc37;
  }
  .applied_main_container {
    height: 200px;
    display: flex;
    flex-direction: column;
  }
  .reasons-box {
    flex-direction: column;
    gap:0px !important;
    padding: 0px !important;
  }
  .reason_of_leave {
    margin-left: 2px;
    padding:0px;
  }
  .box-title{
    margin-bottom:0px !important;
  }
  .approvers-table{
    margin-top:4px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Request/Request.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;;EAEX,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;;EAEhB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,WAAW;IACX,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;AACA;;;;;sCAKsC;;AAEtC;GACG;AACH;;GAEG;;AAEH;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;GAEG;AACH;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,kBAAkB;AACpB;CACC;CACA,gBAAgB;CAChB;CACA;EACC,eAAe;CAChB;AACD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA,sBAAsB;AACtB;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,eAAe;EACf,4EAA4E;EAC5E,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,OAAO;IACP,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,UAAU;IACV,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;GACC;IACC,eAAe;IACf,sBAAsB;EACxB;GACC;IACC,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Karla:wght@400;600;700&display=swap\");\n\n.request-form-container {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  background-color: white;\n}\n\n.request-container {\n  font-family: \"Karla\", sans-serif;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  color: black;\n  padding: 20px;\n  box-sizing: border-box;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.apply-button-container {\n  position: relative;\n  display: flex;\n  gap: 10px;\n  align-self: flex-end;\n}\n\n.apply-button {\n  background-color: #84c7ae;\n  color: white;\n  margin-bottom: 0px;\n  border: 2px solid #84c7ae;\n  padding: 4px 7px;\n  font-family: \"Karla\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.balance-button {\n  margin-right: 20px;\n}\n\n.apply-button:hover {\n  background-color: #75b39d;\n}\n\n.dropdown-menu {\n  position: absolute;\n  margin-top: 5px;\n  top: 100%;\n  right: 0;\n  background-color: white;\n  width: 100%;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n.dropdown-menu button {\n  display: block;\n  width: 100%;\n  padding: 6px;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: \"Karla\", sans-serif;\n  font-size: 12px;\n  color: black;\n  white-space: nowrap;\n}\n\n.dropdown-menu button:hover {\n  background-color: #f0f0f0;\n}\n\nh2 {\n  margin-top: 5px;\n  font-weight: 700;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  flex-grow: 1;\n}\n\ntable {\n  width: 100%;\n\n  /* border-collapse: separate; */\n  border-spacing: 0 5px;\n  margin-top: -5px;\n\n  border: 1px solid #d9e3d9;\n}\n\nth,\ntd {\n  padding: 4px 1px;\n  text-align: left;\n}\n\nth {\n  font-weight: 700;\n  background: rgba(222, 236, 221, 0.32);\n  margin-bottom: 10px;\n}\ntbody tr:nth-child(odd) {\n  /* border: 1px solid #000; */\n  background-color: #c6bcbc37;\n}\n\ntbody td {\n  font-weight: 600;\n  font-size: 11px;\n  text-align: center;\n  /* border-top: 1px solid #d9e3d9; */\n  /* border: 1px solid gray; */\n}\n\n.action-icons {\n  display: flex;\n  gap: 20px;\n}\n\n.action-icon {\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n  color: #84c7ae;\n  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));\n}\n\n.action-icon:hover {\n  opacity: 0.7;\n}\n\n/* Tablet view: 768px to 1023px */\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .request-container {\n    font-family: \"Karla\", sans-serif;\n    width: 100%;\n    height: 100%;\n    background-color: white;\n    color: black;\n    padding: 20px;\n    box-sizing: border-box;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n  }\n  .apply-button-container {\n    position: relative;\n    display: flex;\n    align-self: flex-end;\n  }\n  .applied_main_container {\n    height: 200px;\n    display: flex;\n    flex-direction: column;\n  }\n  .request_heading {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 5px;\n  }\n \n  .table-responsive {\n    overflow-x: auto;\n    flex-grow: 1;\n  }\n  .table-responsive table {\n    width: 100%;\n    /* border-collapse: separate; */\n    border-spacing: 0 5px;\n    margin-top: -5px;\n    border: 1px solid #d9e3d9;\n  }\n  .table-responsive th {\n    background-color: #deecdd;\n    position: sticky;\n    top: 0;\n    text-align: center;\n    font-weight: 700;\n    background: rgba(222, 236, 221, 0.32);\n    margin-bottom: 10px;\n    padding: 4px 1px;\n  }\n  .table-responsive tbody tr:nth-child(odd) {\n    /* border: 1px solid #000; */\n    background-color: #c6bcbc37;\n  }\n  .applied_main_container {\n    height: 200px;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1440px) {\n  .apply-button {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n\n  h2 {\n    font-size: 18px;\n  }\n\n  td {\n    font-size: 12px;\n  }\n\n  .action-icons {\n    gap: 10px;\n  }\n\n  .action-icon {\n    font-size: 14px;\n  }\n}\n/* \n.iconCloseBtn {\n  position: absolute;\n  top: 16%;\n  right: 1%;\n  transform: translateX(-10%, -10%); */\n\n/* z-index: 2;\n} */\n/* .iconCloseBtn:hover {\n  cursor: pointer;\n} */\n\n.alert-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.alert-box {\n  width: 60vw;\n  height: 97vh;\n  max-width: 90%;\n  position: relative;\n}\n\n.close-icon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 1.5rem;\n  color: #fff;\n  cursor: pointer;\n}\n\n/* .close-icon:hover {\n  color: #007bff;\n} */\n\n.request_heading {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 5px;\n}\n.request_highlight_leave {\n  color: rgb(205, 102, 102);\n  cursor: pointer;\n}\n\n/* .requestByMe_container{\n  height: 550px;\n} */\n.applied_main_container {\n  height: 200px;\n  display: flex;\n  flex-direction: column;\n}\n\ntable th {\n  background-color: #deecdd;\n  position: sticky;\n  top: 0;\n  text-align: center;\n}\n .reason-column{\n max-width: 100px;\n }\n .name-column{\n  max-width: 60px;\n }\n.crossIconOfNewAsset {\n  align-content: center;\n  margin-left: 520px;\n  position: absolute;\n  margin-top: 0px;\n  z-index: 2;\n  color: white;\n  font-size: xx-large;\n  font-weight: 600;\n}\n\n.revoke_icon {\n  color: #84c7ae;\n  cursor: pointer;\n  font-size: 20px;\n  margin-left: 10px;\n}\n/* leave balance css */\n.leave-balance-popup {\n  position: fixed;\n  top: 100px;\n  left: 250px;\n  width: 60%;\n  height: auto;\n  max-height: 80%;\n  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  z-index: 1000;\n  border: 5px solid #ccc;\n  border-radius: 10px;\n  overflow-y: auto;\n}\n\n.leaveBalance_heading {\n  font-size: 34px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: #0d7c66;\n}\n\n.leave-balance-list {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 40px;\n  width: 100%;\n  max-width: 800px;\n  margin-bottom: 20px;\n}\n\n.leave-balance-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  width: 120px;\n  position: relative;\n}\n\n.leave-balance-item:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  right: -20px;\n  top: 20%;\n  height: 60%;\n  width: 1px;\n  background-color: #ccc;\n}\n\n.leave-day_border {\n  height: 4rem;\n  width: 4rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #84c7ae;\n  border: #75b39d 3px solid;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.leave-type {\n  font-size: 18px;\n  font-weight: 500;\n  color: #0d7c66;\n  margin-top: 10px;\n  text-align: center;\n}\n\n.leave-days {\n  font-size: 24px;\n  font-weight: 700;\n  color: white;\n}\n\n.crossIconOfleaveBalance {\n  top: 10px;\n  right: 10px;\n  position: absolute;\n  z-index: 2;\n  color: rgb(96, 88, 88);\n  font-size: x-large;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 767px) {\n  .request-container {\n    padding: 10px;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .apply-button-container {\n    flex-direction: row;\n    /* align-items: initial; */\n    width: 100%;\n    gap: 5px;\n  }\n\n  .apply-button {\n    font-size: 12px;\n    padding: 6px 10px;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .dropdown-menu {\n    width: 100% !important;\n    right: 0;\n    left: 0;\n    top: 100%;\n  }\n\n  .popup-main {\n    width: 100%;\n    padding: 10px;\n    overflow-y: auto;\n    max-height: 90vh;\n  }\n\n  .crossIconOfNewAsset,\n  .crossIconOfleaveBalance {\n    margin-left: auto !important;\n    margin-right: 10px;\n    position: absolute;\n    top: 9px;\n    right: -4px;\n    font-size: 20px;\n  }\n\n  .leave-balance-popup {\n    top: 60px;\n    left: 5%;\n    width: 90%;\n    padding: 15px;\n    border: 3px solid #ccc;\n  }\n\n  .leaveBalance_heading {\n    font-size: 24px;\n  }\n\n  .leave-balance-list {\n    gap: 20px;\n  }\n\n  .leave-type {\n    font-size: 14px;\n  }\n\n  .leave-days {\n    font-size: 20px;\n  }\n\n  .table-responsive {\n    overflow-x: auto;\n    height: 200px;\n  }\n\n  table {\n    font-size: 12px;\n    min-width: 600px;\n  }\n\n  .request_heading {\n    font-size: 16px;\n    text-align: center;\n  }\n\n  .action-icon {\n    font-size: 16px;\n  }\n\n  .alert-box {\n    width: 95vw;\n    height: 90vh;\n  }\n\n  .applied_main_container {\n    height: auto;\n  }\n\n  .table-responsive td {\n    padding: 0px;\n  }\n  .apply-button-container button {\n    font-size: medium;\n  }\n}\n\n@media screen and (max-width: 550px) {\n  .request-container {\n    padding: 8px;\n  }\n\n  .apply-button {\n    font-size: 10px;\n    padding: 4px 8px;\n  }\n\n  .leaveBalance_heading {\n    font-size: 20px;\n  }\n\n  .leave-type {\n    font-size: 12px;\n  }\n\n  .leave-days {\n    font-size: 18px;\n  }\n   table{\n    font-size: 12px;\n    min-width: fit-content;\n  }\n   .table-responsive {\n    overflow-x: auto;\n    min-width: 300px;\n  }\n  .table-responsive table {\n    /* width: 100%; */\n    /* border-collapse: separate; */\n    border-spacing: 0 5px;\n    margin-top: -5px;\n    border: 1px solid #d9e3d9;\n  }\n  .table-responsive th {\n    background-color: #deecdd;\n    position: sticky;\n    top: 0;\n    text-align: center;\n    font-weight: 550;\n    background: rgba(222, 236, 221, 0.32);\n    margin-bottom: 10px;\n    padding: 2px 1px;\n  }\n  .table-responsive tbody tr:nth-child(odd) {\n    /* border: 1px solid #000; */\n    background-color: #c6bcbc37;\n  }\n  .applied_main_container {\n    height: 200px;\n    display: flex;\n    flex-direction: column;\n  }\n  .reasons-box {\n    flex-direction: column;\n    gap:0px !important;\n    padding: 0px !important;\n  }\n  .reason_of_leave {\n    margin-left: 2px;\n    padding:0px;\n  }\n  .box-title{\n    margin-bottom:0px !important;\n  }\n  .approvers-table{\n    margin-top:4px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
